/* pkg: Sales FAT Client (js/Sales-FAT.js)*/
require("./js//Sales.js");
require("./js//ContractSearchCombo.js");
require("./js//CustomerSearchCombo.js");
require("./js//OfferSearchCombo.js");
require("./js//InvoiceSearchCombo.js");
require("./js//SupplierSearchCombo.js");
require("./js//ContractProductFilterModel.js");
require("./js//ContractGridPanel.js");
require("./js//ContractEditDialog.js");
require("./js//ProductGridPanel.js");
require("./js//ProductEditDialog.js");
require("./js//CustomerEditDialog.js");
require("./js//SupplierEditDialog.js");
require("./js//AddressGridPanel.js");
require("./js//DeliveryAddressGridPanel.js");
require("./js//BillingAddressGridPanel.js");
require("./js//AddressEditDialog.js");
require("./js//CustomerDetailsPanel.js");
require("./js//SupplierDetailsPanel.js");
require("./js//CustomerGridPanel.js");
require("./js//SupplierGridPanel.js");
require("./js//ExceptionHandler.js");
require("./js//CopyAddressDialog.js");
require("./js//OrderConfirmationEditDialog.js");
require("./js//ContractFilterModel.js");
require("./js//CustomerFilterModel.js");
require("./js//SupplierFilterModel.js");
require("./js//InvoiceEditDialog.js");
require("./js//PurchaseInvoiceEditDialog.js");
require("./js//InvoicePositionGridPanel.js");
require("./js//InvoicePositionPanel.js");
require("./js//InvoiceGridPanel.js");
require("./js//PurchaseInvoiceGridPanel.js");
require("./js//AddressSearchCombo.js");
require("./js//OrderConfirmationSearchCombo.js");
require("./js//InvoiceDetailsPanel.js");
require("./js//PurchaseInvoiceDetailsPanel.js");
require("./js//OrderConfirmationFilterModel.js");
require("./js//BillingDateDialog.js");
require("./js//OfferEditDialog.js");
require("./js//PurchaseInvoiceApproverFilterModel.js");
require("./js//ProductAggregateGridPanel.js");
/* pkg: Sales FAT Client (css/Sales-FAT.css)*/
require("./css//Sales.css");
